import { Injectable, ElementRef, Input, ViewChild } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Router, RouterLink } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AppConfig } from '../config/app.config';
import { GetUnixService } from './get-unix.service';
import { SpinnerService } from './spinner.service';

@Injectable()
export class FileUploadService {
    constructor(private http: HttpClient,
        private toastrService: ToastrService,
        private getUnixService: GetUnixService,
        private spinnerService: SpinnerService,
        private router: Router) {
    }

    dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    upload(image) {
        return new Observable((observer) => {
            this.spinnerService.displayLoader(true);
            const formData = new FormData();
            // const newImg = new Buffer(image, 'base64');
            const imageExt = image.split(';')[0].split(':')[1].split('/')[1];
            const imageName = this.getUnixService.getEpochCurrent() + '' + Math.random() + '.' + imageExt;
            let file = this.dataURLtoFile(image, imageName);
            // const imgBlob = new Blob([image], {type: imageExt});
            if (file.size < 5242880) {
                formData.append('data', file, imageName);
                // formData.append('image', file);

                // formData.append('image_name',imageName);
                // formData.append('image_extension',imageExt);
                this.http.post(AppConfig.API_ENDPOINT + AppConfig.fileUpload, formData)
                    .subscribe(
                        (data: any) => {
                            if (data.status == 0) {
                                this.toastrService.clear();
                                this.toastrService.error(data.data.message, 'Error');
                                this.spinnerService.displayLoader(false);
                                return observer.error();
                            } else {
                                this.spinnerService.displayLoader(false);
                                observer.next(imageName);
                            }
                        },
                        (error) => {
                            if (error.status === 401) {
                                this.toastrService.clear();
                                this.toastrService.error(error.statusText, 'Error');
                                this.spinnerService.displayLoader(false);
                            } else {
                                this.toastrService.error(error, 'Error');
                                this.spinnerService.displayLoader(false);
                            }
                        },
                        () => { 
                            // console.log('Request complete'); 
                        });
            }
            else {   
                this.toastrService.error('Images should be less than 5Mb', 'Error');
                this.spinnerService.displayLoader(false);
                this.toastrService.clear();
             
                return observer.next(0);
            }

        });
    }
}


// WEBPACK FOOTER //
// C:/Users/neenu.korula/AA/eventorg-web/src/app/services/upload.service.ts